import { SECTIONS } from "../../../../config/constants";
import { Tabs, Input, Tree, Spin } from "antd";
import { useEffect, useState } from "react";
import "./ReleaseNotes.css";
import PageHead from "../../../layout/PageHead";
import GroupCodesService from "../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../services/tables/TablesService";
import { useTranslation } from "react-i18next";
import {
  DiffOutlined,
  CarryOutOutlined,
  FormOutlined,
} from "@ant-design/icons";
import styles from "./ReleaseNotes.module.css";
import { DataNode } from "antd/lib/tree";
import WikiService from "../../../../services/wiki/WikiService";
import {ROUTES} from "../../../../config/consts/routes";

const { Search } = Input;

const { TabPane } = Tabs;

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.report.name,
  },
  {
    path: ROUTES.report.demo.route,
    breadcrumbName: ROUTES.report.releaseNotes.name,
  },
];

const ReleaseNotes = () => {
  const { t, i18n } = useTranslation("translations");
  const [data, setData] = useState<any>([]);
  const [selectedPage, setSelectedPage] = useState<any>([]);
  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();

  const [showLine, setShowLine] = useState<boolean>(true);
  const [isPageLoading, setIsPageLoading] = useState<boolean>(false);
  const [isPageTreeLoading, setIsPageTreeLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsPageTreeLoading(true);
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });
    WikiService.getPages(2).then((response: any) => {
      const data = response.data;
      const items = unflatten(data);
      
      setData(items);
      setIsPageTreeLoading(false);
    });
  }, []);

  const unflatten = (data: any) => {
    const queryParamVersion = null;

    const distinctValues: any = [];
    const sortedValues: any = data.sort((a: any, b: any) => {
      if (a.originalPath > b.originalPath) {
          return 1;
      }
      if (a.originalPath < b.originalPath) {
          return -1;
      }

      if (a.version > b.version)
        return 1;
      if (a.version < b.version)
        return -1;
      return 0;
    });

    for (let index = 0; index < sortedValues.length; index++) {
        if (!distinctValues.some((p: any) => p.originalPath === sortedValues[index].originalPath)) {
            distinctValues.push(sortedValues[index])
        };
    };
    
    const tree = distinctValues.map((e: any) => ({ ...e, icon: <CarryOutOutlined /> }))
      // .filter((p: any) => p.version === (searchParams.get("v") ?? selectedVersion.value))
      .sort((a:any, b:any) => a.id - b.id)
      .reduce((a:any, e:any) => {
        a[e.id] = a[e.id] || e;
        a[e.parentID] = a[e.parentID] || {};
        const parent = a[e.parentID];
        parent.children = parent.children || [];
        parent.children.push(e);
        return a;
      }, {});
      // return Object.values<any>(tree).find((e:any) => e.id === undefined)?.children;
      return tree.null.children;
  };

  // const treeData: DataNode[] = [
  //   {
  //     title: "parent 1",
  //     key: "0-0",
  //     icon: <CarryOutOutlined />,
  //     children: [
  //       {
  //         title: "parent 1-0",
  //         key: "0-0-0",
  //         icon: <CarryOutOutlined />,
  //         children: [
  //           { title: "leaf", key: "0-0-0-0", icon: <CarryOutOutlined /> },
  //           {
  //             title: (
  //               <>
  //                 <div>multiple line title</div>
  //                 <div>multiple line title</div>
  //               </>
  //             ),
  //             key: "0-0-0-1",
  //             icon: <CarryOutOutlined />,
  //           },
  //           { title: "leaf", key: "0-0-0-2", icon: <CarryOutOutlined /> },
  //         ],
  //       },
  //       {
  //         title: "parent 1-1",
  //         key: "0-0-1",
  //         icon: <CarryOutOutlined />,
  //         children: [
  //           { title: "leaf", key: "0-0-1-0", icon: <CarryOutOutlined /> },
  //         ],
  //       },
  //       {
  //         title: "parent 1-2",
  //         key: "0-0-2",
  //         icon: <CarryOutOutlined />,
  //         children: [
  //           { title: "leaf", key: "0-0-2-0", icon: <CarryOutOutlined /> },
  //           {
  //             title: "leaf",
  //             key: "0-0-2-1",
  //             icon: <CarryOutOutlined />,
  //             switcherIcon: <FormOutlined />,
  //           },
  //         ],
  //       },
  //     ],
  //   },
  //   {
  //     title: "parent 2",
  //     key: "0-1",
  //     icon: <CarryOutOutlined />,
  //     children: [
  //       {
  //         title: "parent 2-0",
  //         key: "0-1-0",
  //         icon: <CarryOutOutlined />,
  //         children: [
  //           { title: "leaf", key: "0-1-0-0", icon: <CarryOutOutlined /> },
  //           { title: "leaf", key: "0-1-0-1", icon: <CarryOutOutlined /> },
  //         ],
  //       },
  //     ],
  //   },
  // ];

  const onTreeItemSelect = (selectedKeys: React.Key[], info: any) => {
    setIsPageLoading(true);
    WikiService.get(info.node.originalPath, "en").then((response: any) => {
      const data = response.data;
      setSelectedPage(data);
      setIsPageLoading(false);
    });
  };

  // const onTreeItemSelect = (value: any, selectedNode: any) => {
  //   WikiService.get(selectedNode.id, "en").then((response: any) => {
  //     const data = response.data;
  //     setSelectedPage(data);
  //   });
  // }

  return (
    <div className="notes-tree">
      <PageHead
        title={t("Page.Report.Documentation.Headers.ReleaseNotes", {
          lngs: i18n.languages,
          defaultValue: "Release Notes",
        })}
        icon={<DiffOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={true}
        setSelectEntityDisabled={true}
        setSelectOperationDisabled={true}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={true}
      />
      <div className={styles.bodyContainer}>
        <div className={styles.leftNavigation}>
          <Search
            placeholder={
              t("Page.Report.Documentation.Labels.Search", {
                lngs: i18n.languages,
                defaultValue: "Enter value to search",
              })!
            }
            //   value={applyMappingTemplateSearchInput}
            //   onChange={(e) => onApplyMappingTemplateSearch(e.target.value)}
          />
          {isPageTreeLoading ? (
            <Spin></Spin>
          ) : (
            <Tree
              showLine={showLine}
              // showIcon={showIcon}
              defaultExpandedKeys={["0-0-0"]}
              onSelect={onTreeItemSelect}
              treeData={data}
            />
          )}
        </div>
        <div className={styles.rightContent}>
          {isPageLoading ? (
            <Spin></Spin>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: selectedPage?.content }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotes;
function renderTitle(arg0: string) {
  throw new Error("Function not implemented.");
}
